import { createContext, useContext } from "react";

import { MatchCardContextType } from "./match_card_context.types";

export const MatchCardContext = createContext<MatchCardContextType>({} as MatchCardContextType);

export const useMatchCardContext = () => useContext(MatchCardContext);
